import authenticate from '@/middleware/authenticate'
import store from '@/store'

export default [
  {
    path: '/card-profiles',
    name: 'card-profile',
    meta: { middleware: authenticate },
    component: () => import('@/pages/administration/card-profile/index.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('administration/cardProfile/dataBeforeCreate')
      next()
    }
  },
  {
    path: '/card-profiles/create',
    name: 'card-profile-create',
    meta: { middleware: authenticate },
    component: () => import('@/pages/administration/card-profile/create.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('administration/cardProfile/dataBeforeCreate')
      next()
    }
  },
  {
    path: '/card-profiles/:id',
    name: 'card-profile-edit',
    meta: { middleware: authenticate },
    component: () => import('@/pages/administration/card-profile/edit.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('administration/cardProfile/dataBeforeCreate')
      await store.dispatch('administration/cardProfile/find', to.params.id)
      next()
    }
  }
]
